import { render, staticRenderFns } from "./deals-form.vue?vue&type=template&id=63495349&"
import script from "./deals-form.vue?vue&type=script&lang=js&"
export * from "./deals-form.vue?vue&type=script&lang=js&"
import style0 from "./deals-form.vue?vue&type=style&index=0&id=63495349&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports